import { render, staticRenderFns } from "./AdditionalInformationWrapper.vue?vue&type=template&id=eafbdeb0&scoped=true"
import script from "./AdditionalInformationWrapper.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafbdeb0",
  null
  
)

export default component.exports